import Confirmacion from '../../spa/pagos/confirmacion';

export default {
  path: 'confirmacion/:idPedido',
  name: 'confirmacion',
  component: Confirmacion,
};



// WEBPACK FOOTER //
// ./src/config/router/confirmacion.js